import { AssessmentStatus as Assessment_Status_Enum } from '@risksmart-app/domain/src/types/consts/assessment-status';
import type { FC } from 'react';
import { useNavigate } from 'react-router';
import { ownerContributorAndViewerIds } from 'src/components/form';
import { PageWrapper } from 'src/components/form/form/PageWrapper';

import { useInsertAssessment } from '@/hooks/mutations/assessment/useInsertAssessment';
import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { useIsFormPrefillEnabled } from '@/hooks/useIsFormPrefillEnabled';
import { assessmentDetailsUrl } from '@/utils/urls';

import AssessmentForm from '../../forms/assessment-form';
import type { AssessmentFormDataFields } from '../../forms/assessment-form/assessmentSchema';

const AssessmentCreateTab: FC = () => {
  const navigate = useNavigate();
  const { insertAssessment } = useInsertAssessment();
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const formPrefillEnabled = useIsFormPrefillEnabled();

  const onSave = async (variables: AssessmentFormDataFields) => {
    const data = await insertAssessment({
      CustomAttributeData: variables.CustomAttributeData || undefined,
      ...ownerContributorAndViewerIds(variables),
      TagTypeIds: variables.tags?.map((t) => t.TagTypeId) || [],
      DepartmentTypeIds:
        variables.departments?.map((d) => d.DepartmentTypeId) || [],
      CompletedByUser: variables.CompletedByUser?.value ?? null,
      Status: variables.Status ?? Assessment_Status_Enum.NotStarted,
      StartDate: variables.StartDate,
      Title: variables.Title,
      Summary: variables.Summary,
      ActualCompletionDate: variables.ActualCompletionDate,
      NextTestDate: variables.NextTestDate,
      TargetCompletionDate: variables.TargetCompletionDate,
      Outcome: variables.Outcome,
      OriginatingItemId: null,
    });
    const assessmentId = data?.insertAssessmentApi?.Id;
    if (!assessmentId) {
      throw new Error('Missing assessment id');
    }

    return {
      savedIds: [assessmentId],
      createdEntity: {
        id: assessmentId,
        destination: assessmentDetailsUrl(assessmentId),
      },
      successNavigation: {
        destination: assessmentDetailsUrl(assessmentId),
        isReplace: true,
      },
    };
  };

  const onDismiss = (saved?: boolean) => {
    if (!saved) {
      navigate(-1);
    }
  };

  return (
    <AssessmentForm
      onSave={onSave}
      onDismiss={onDismiss}
      publishToolbarState={objectToolbarEnabled}
      publishActiveForm={formPrefillEnabled}
      renderTemplate={(renderProps) => <PageWrapper {...renderProps} />}
    />
  );
};

export default AssessmentCreateTab;
